export enum PaymentMethodType {
Cash,
Check,
BankTransfer,
}
